import { ActionTree } from "vuex";
import { ForexState } from "./interface";
import { IStoreRootState } from "@/store/interface";
import { ForexAction, ForexMutation } from "@/feature/Forex/store/constants";
import { $getForexCount, $getForexCourse } from "@/feature/Forex/api/forex";

export default <ActionTree<ForexState, IStoreRootState>> {

	async [ForexAction.loadCourse]({ commit }) {
		const course = await $getForexCourse();

		commit(ForexMutation.setCourse, course);

		return course;
	},

	async [ForexAction.loadCount]({ commit }) {
		const forexCount = await $getForexCount();

		commit(ForexMutation.setCount, forexCount);

		return forexCount;
	}

}